// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import {
  FulfillmentOrder,
  fulfillmentOrderSchema,
} from '@/fulfillment/api/types';
import { z } from 'zod';

const getFulfillmentResponseSchema = z.object({
  data: fulfillmentOrderSchema,
  metadata: responseMetadataSchema,
});

/**
 * Fetches a single fulfillment order by its key.
 */
export async function getFulfillment(
  fulfillmentKey: string
): Promise<FulfillmentOrder> {
  const url = `/v1/fulfillment/${fulfillmentKey}`;
  const response = await api.get(url);

  const { data } = await parseResponse(
    getFulfillmentResponseSchema,
    response.data,
    {
      schemaName: 'GetFulfillment',
      endpoint: url,
    }
  );
  return data;
}
